// initial state
const state = () => ({
  validation: { open: false },
  accept: { open: false },
  reject: { open: false },
});

// actions
const actions = {
  async openDialog({ commit }, type) {
    commit("SET_OPEN", [type, true]);
  },
  async closeDialog({ commit }, type) {
    commit("SET_OPEN", [type, false]);
  },
};

// mutations
const mutations = {
  SET_OPEN(state, [type, open]) {
    state[type].open = open;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
